import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import SearchFilter from 'components/_common/SearchFilter';
import PageUtil from 'utils/Page.util';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { DateType, getReceptionType, getProofType, getPaymentMethod, getReceptionStatus, ReceptionType, PaymentMethod } from 'enums/reception.enum';


const EstimateV = ({
    params,
    setParams,
    handleChange,
    onSearch,
    setSearch,
    onClearFilter,
    onToggleDatePickerMode,
    onHandleSearchDate,
    onOpenCreate,
    onOpenEdit,
    onOpenTripCard,
    onChangeStatus,
    onTodaySearch,
    getTotalSummary,
    handleExportExcel,
}) => {
    const { list, isLoaded, error, search, stats } = params;

    const dateTypeOptions = [
        { value: DateType.RECEIVED, label: '접수일자' },
        { value: DateType.ESTIMATE, label: '견적일자' }
    ];

    // 검색 매개변수 변경 핸들러
    const handleSearchChange = (field, value) => {
        const cur = PageUtil.deepCopy(params);
        cur.search[field] = value;
        setParams(cur);
    };

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>견적관리</span>
                        </h1>
                    </div>

                    <div className="container-fluid">
                        {/* 견적 통계 카드 영역 */}
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="card card-outline card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-chart-bar mr-2"></i>
                                            금일 견적 통계
                                        </h3>
                                        <div className="card-tools">
                                            <span className="text-muted small">
                                                {PageUtil.getCurrentDate()} 기준
                                            </span>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {/* 견적건수 */}
                                            <div className="col-md-4 col-sm-6">
                                                <div className="info-box bg-info">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-file-contract"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">견적건수</span>
                                                        <span className="info-box-number text-white">
                                                            {stats?.estimateCount || 0}건
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            오늘 발행된 견적서
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 견적금액 */}
                                            <div className="col-md-4 col-sm-6">
                                                <div className="info-box bg-success">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-won-sign"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">견적금액</span>
                                                        <span className="info-box-number text-white">
                                                            {PageUtil.formatToKRW(stats?.estimateAmount || 0 + stats?.tripFee || 0)}
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            총 견적 금액
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 이익합계 */}
                                            <div className="col-md-4 col-sm-6">
                                                <div className="info-box bg-danger">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-chart-line"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">이익합계</span>
                                                        <span className="info-box-number text-white">
                                                            {PageUtil.formatToKRW(stats?.totalProfit || 0)}
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{
                                                                width: stats?.estimateAmount > 0 ? `${Math.max(10, (stats.totalProfit / stats.estimateAmount) * 100)}%` : '0%',
                                                                backgroundColor: 'rgba(255,255,255,0.4)'
                                                            }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            순이익 ({stats?.estimateAmount > 0 ? ((stats.totalProfit / stats.estimateAmount) * 100).toFixed(1) : '0'}%)
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 고급 검색 필터 */}
                        <SearchFilter
                            searchParams={search}
                            onSearchChange={handleSearchChange}
                            onSearch={onSearch}
                            onClearFilter={onClearFilter}
                            todayButtonName={"견적 Today"}
                            onTodaySearch={onTodaySearch}
                            showStatusFilter={true}
                            showTypeFilter={true}
                            showDateRange={true}
                            showDateType={true}
                            showManufactureMonthRange={true}
                            showModelName={true}
                            showRepairNote={true}
                            dateTypeOptions={dateTypeOptions}
                            showEstimateAmount={true}
                            placeholder="고객명, 연락처, 보일러명 등 검색"
                            onExcelDownload={handleExportExcel}
                        />

                        {/* 목록 */}
                        <div className="card card-outline card-dark">
                            <div className="card-header">
                                <div className="card-title">접수 목록</div>
                                <div className="card-tools">
                                    <span className="badge bg-primary mr-1" style={{ fontSize: '14px', padding: '6px 10px' }}>
                                        견적 {PageUtil.formatToKRW(params.estimateAmount)}원
                                    </span>
                                    <span className="badge bg-success mr-1" style={{ fontSize: '14px', padding: '6px 10px' }}>
                                        이익 {PageUtil.formatToKRW(params.totalProfit)}원
                                    </span>
                                    <span className="badge bg-secondary" style={{ fontSize: '14px', padding: '6px 10px' }}>
                                        총 {PageUtil.formatToKRW(params.total)}건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: 120 }}>처리상황</th>
                                                <th>처리유형</th>
                                                <th>견적일자</th>
                                                <th>고객명</th>
                                                <th>연락처</th>
                                                <th>총수리/판매내역</th>
                                                <th>견적금액</th>
                                                <th>총수리원가</th>
                                                <th>출장비(고객)</th>
                                                <th>출장비용(출장자)</th>
                                                <th>물류비</th>
                                                <th>결제내역</th>
                                                <th>증빙유형</th>
                                                <th>견적서확인</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row) => (
                                                <tr key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6' } : {}}>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={row.status || ''}
                                                            onChange={(e) => onChangeStatus(row, e.target.value)}
                                                            style={{
                                                                color: row.status === 'ARREARS' ? '#dc3545' : '',
                                                                fontWeight: row.status === 'ARREARS' ? 'bold' : '',
                                                                fontSize: row.status === 'ARREARS' ? '15px' : '',
                                                            }}
                                                        >
                                                            {params.statusSet.map((s) => (
                                                                <option key={s.value} value={s.value} style={{ textAlign: 'center' }}>
                                                                    {s.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE || row.type == ReceptionType.EXCHANGE ? ' bg-danger' : 'bg-info')}
                                                            style={{ fontSize: '15px', padding: '5px 10px' }} // 글자 크기와 여백 추가
                                                        >
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.estimateDate || ''}
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>
                                                        <a onClick={() => onOpenEdit(row)} style={{ cursor: 'pointer' }}>
                                                            {row.phone1 || ''}
                                                        </a>
                                                    </td>
                                                    <td className="text-end">
                                                        <strong className="text-success">
                                                            {/* 수리/판매내역 요약 표시 */}
                                                            {getTotalSummary(row)}
                                                        </strong>
                                                    </td>
                                                    <td className="text-end">
                                                        <strong className="text-primary">
                                                            {/* {PageUtil.formatToKRW(row.estimateAmount || 0)} */}
                                                            {PageUtil.formatToKRW((row.estimateAmount || 0) + (row.tripFee || 0))}
                                                        </strong>
                                                    </td>
                                                    <td className="text-end">
                                                        <strong className="text-danger">
                                                            {PageUtil.formatToKRW(row.repairCost || 0)}
                                                        </strong>
                                                    </td>
                                                    <td className="text-end">
                                                        <strong className="text-primary">
                                                            {PageUtil.formatToKRW(row.tripFee || 0)}
                                                        </strong>
                                                    </td>
                                                    <td className="text-end">
                                                        <strong className="text-warning">
                                                            {PageUtil.formatToKRW(row.tripFeeAmount || 0)}
                                                        </strong>
                                                    </td>
                                                    <td className="text-end">
                                                        <strong className="text-info">
                                                            {PageUtil.formatToKRW(row.logisticsFee || 0)}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        <span className={"badge " + (row.paymentMethod == PaymentMethod.ARREARS ? ' bg-danger' : 'bg-secondary')}>
                                                            {getPaymentMethod().find((p) => p.value === row.paymentMethod)?.label || row.paymentMethod}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <small className="badge bg-light text-dark">
                                                            {getProofType().find((p) => p.value === row.proofType)?.label || row.proofType}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        <small className="badge bg-light text-dark">
                                                            {row.estimateIssueDate ? 'Y' : 'N'}
                                                        </small>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* 페이징 */}
                            {list.length > 0 && (
                                <PaginationControl
                                    page={params.search.page}
                                    total={params.total}
                                    limit={params.search.rows}
                                    changePage={(page) => {
                                        const cur = PageUtil.deepCopy(params);
                                        cur.search.page = page;
                                        setParams(cur);
                                        setSearch(true);
                                    }}
                                    ellipsis={1}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default EstimateV;